import { useEffect, useState } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";

const PersistLogin = ({ children }) => {

	const [isLoading, setIsLoading] = useState(true);
	const { auth } = useAuth();
	const refreshToken = useRefreshToken();

	useEffect(() => {
		let isMounted = true;

		const verifyRefreshToken = async () => {
			try {
				await refreshToken();
			} catch(err) {
				console.error(err);
			} finally {
				isMounted && setIsLoading(false);
			}
		};

		!auth?.accessToken ? verifyRefreshToken() : setIsLoading(false);

		return () => isMounted = false;
	}, []);

	return children;

	// return  isLoading
	//             ? <p>Cargando...</p>
	//             : children;
};

export default PersistLogin;